module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "change-password-wrapper"
  }, [_c('div', {
    staticClass: "change-password col-md-6 col-lg-5 col-xl-4"
  }, [_c('h2', {
    staticClass: "title row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v(" ")]), _c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v(_vm._s(_vm.title))])]), _c('br'), _c('SmartForm', {
    attrs: {
      "labelSize": 4,
      "formList": _vm.formList,
      "columns": _vm.columns,
      "buttonList": _vm.buttonList
    },
    model: {
      value: (_vm.formValues),
      callback: function($$v) {
        _vm.formValues = $$v
      },
      expression: "formValues"
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e58114d2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Setting/ChangePassword.vue
// module id = 1803
// module chunks = 1